<template>
  <span
    class="toggle-icon icon"
    @click="toggleModal"
    v-bind:class="{ 
      'icon-stihl-dropdown-up-arrow': isModalOpen, 
      'icon-stihl-dropdown-down-arrow': !isModalOpen
    }"
  ></span>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ToggleIcon",
  computed: {
    ...mapGetters("DealerHeader", ["isModalOpen"])
  },
  methods: {
    ...mapActions('DealerHeader', [
      'toggleModal'
    ]),
     toggleModal() {
       if (this.isModalOpen) {
         this.$dataLayer.push({ event: "pcedh.header-closed" })
      } else {
        this.$dataLayer.push({ event: "pcedh.header-opened" })
      }
      this.$store.dispatch("DealerHeader/toggleModal")
    }
  },
};
</script>
<style lang="scss" scoped>
.toggle-icon {
  cursor: pointer;
  color: $icon-primary;
}
</style>